<div class=" header bg-gradient-nhc-orange pb-6">
  <div class=" container-fluid">
    <div class=" header-body">
      <div class=" row align-items-center py-4">
        <div class=" col-lg-12 col-12">
          <nav
            aria-label="breadcrumb"
            class=" d-none d-md-inline-block ml-md-4"
          >
            <ol class=" breadcrumb breadcrumb-links breadcrumb-dark">
              <li class=" breadcrumb-item">
                <a [routerLink]="['/']" href="javascript:void(0)">
                  <i class=" fas fa-home"></i>
                </a>
              </li>

              <li class=" breadcrumb-item">
                <a [routerLink]="['/external-active-assignment']" href="javascript:void(0)"> Active assignments </a>
              </li>

              <li class=" breadcrumb-item">
                <a href="javascript:void(0)"> Active assignments details </a>
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class=" container-fluid mt--6">

  <section class="section" id="project-detail">
    <div class="row">
      <div class="col-lg-8 col-md-12 col-sm-12">
        <div class=" card-wrapper" id="projectInfo">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-md-9 col-lg-9 col-sm-12">
                  <h3 class=" mb-0">Project Information</h3>
                </div>
              </div>


            </div>
            <div class="card-body">

              <div class="form-group">
                <h4>Name</h4>
                <p class="text-muted">{{ assigmentDetail?.projectDetail?.projectName }}</p>
              </div>
              <div class="form-group">
                <h4>Description</h4>
                <p class="text-muted">{{ assigmentDetail?.projectDetail?.projectDescription }}</p>
              </div>
              <div class="row">
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Budget Frame</h4>
                  <p
                    class="text-muted">{{ assigmentDetail?.projectDetail?.budgetFrame|number:'1.00' }}{{ " " }}{{ assigmentDetail?.projectDetail?.currencyCode }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Application Deadline</h4>
                  <p class="text-muted">{{ assigmentDetail?.projectDetail?.dueDate|date:'dd/MM/yyyy' }}</p>
                </div>
                <div class="form-group  col-lg-4 col-md-4 col-sm-12">
                  <h4>Type of support</h4>
                  <ul style="list-style: none; padding-left: 0" class="text-muted">
                    <li *ngFor="let support of assigmentDetail?.projectDetail?.typeOfSupports">
                      {{ support.trim() }}
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-md-9 col-lg-9 col-sm-12">
                <h3 class="mb-0">Sign Document</h3>
              </div>

            </div>
            <div class="row mt-3">
              <div class="col-12">

                <ng-container *ngTemplateOutlet="getButtonTemplate(assigmentDetail)"></ng-container>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>

  </section>

  <div class=" card-wrapper">
    <form (ngSubmit)="onSubmit()" [formGroup]="contractForm">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col-md-9 col-lg-9 col-sm-12">
              <h3 class=" mb-0">Contract Details</h3>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="p-2 mb-2">

            <div class="row">
              <div class="col-md-6 col-lg-6 col-sm-12">
                <div class="form-group row">
                  <label class="col-md-3 col-form-label form-control-label">
                    Start-End Date
                  </label>
                  <div class="col-md-9">
                    <input
                      [bsConfig]="{    rangeInputFormat: 'DD/MM/YYYY',    dateInputFormat: 'DD/MM/YYYY',    showWeekNumbers: false  }"
                      [ngClass]="{ 'is-invalid': contractForm.get('dateRange')?.invalid
                               && contractForm.get('dateRange')?.touched }"
                      bsDaterangepicker
                      class="form-control"
                      formControlName="dateRange"
                      placeholder="Select Start and End Date"
                      type="text"
                    />
                    <div class="invalid-feedback">
                      Start Date - End Date is required.
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-md-6 col-lg-6 col-sm-12">

              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Job description
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('jobDescription')?.invalid
                               && contractForm.get('jobDescription')?.touched }"
                        class="form-control"
                        formControlName="jobDescription" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Job description is required.
              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Working hours
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('workingHour')?.invalid
                               && contractForm.get('workingHour')?.touched }"
                        class="form-control"
                        formControlName="workingHour" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Working hours is required.
              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Termination of contract
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('terminationOfContract')?.invalid
                               && contractForm.get('terminationOfContract')?.touched }"
                        class="form-control"
                        formControlName="terminationOfContract" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Termination of contract is required.
              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Termination of contract
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('terminationOfContract')?.invalid
                               && contractForm.get('terminationOfContract')?.touched }"
                        class="form-control"
                        formControlName="terminationOfContract" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Termination of contract is required.
              </div>
            </div>

            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Honorarium
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('honorarium')?.invalid
                               && contractForm.get('honorarium')?.touched }"
                        class="form-control"
                        formControlName="honorarium" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Honorarium is required.
              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Honorarium to be paid
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('honorariumToBePaid')?.invalid
                               && contractForm.get('honorariumToBePaid')?.touched }"
                        class="form-control"
                        formControlName="honorariumToBePaid" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Honorarium to be paid is required.
              </div>
            </div>
            <div class="form-group">
              <label class="form-control-label" style="display: block">
                Coverage of expenses
              </label>
              <textarea [ngClass]="{ 'is-invalid': contractForm.get('coverageOfExpenses')?.invalid
                               && contractForm.get('coverageOfExpenses')?.touched }"
                        class="form-control"
                        formControlName="coverageOfExpenses" rows="7">
                  </textarea>
              <div class="invalid-feedback">
                Coverage of expenses is required.
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button [routerLink]="['/external-active-assignment']" class="btn btn-secondary" type="button">Back</button>
        </div>
      </div>

    </form>


  </div>
</div>

<!-- Define templates for buttons below -->
<ng-template #signDocumentTemplate>
  <button (click)="redirectToSignUrl()" class="btn btn-primary btn-icon">
    <i class="fa fa-signature"></i> Sign Document
  </button>
</ng-template>

<ng-template #downloadDocumentTemplate>
  <button (click)="downloadFSA()" class="btn btn-outline-primary btn-icon ml-2">
    <i class="fa fa-download"></i> Download Document
  </button>
</ng-template>

<ng-template #rejectedDocumentTemplate>
  <div>
    <p class="text-danger"><i class="fa fa-times-circle"></i> Rejected</p>
  </div>
</ng-template>
<ng-template #loadingDocumentTemplate>
  <div>
    <p class="text-primary">Loading...</p>
  </div>
</ng-template>
<ng-template #SignedTemplate>
  <div>
    <p class="text-success"><i class="fa fa-check-circle"></i> Signed</p>
  </div>
</ng-template>



